import React, { useState, useEffect } from 'react';
import { Grid, Drawer, Button, useMediaQuery } from '@mui/material'; // Using Material-UI components
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Constants } from '../../endPoints';
import Breadcumb from '../../Layouts/Breadcumb';
import Shopsidebar from '../Shopsidebar/Shopsidebar';
import { jwtDecode } from 'jwt-decode';
import { useLocation } from "react-router-dom";

const countryCurrencySymbols = {
  Algeria: 'DA',
  Argentina: 'ARS',
  Australia: 'AUD',
  Austria: '€',
  Bahrain: 'BHD',
  Brazil: 'BRL',
  Canada: 'CA$',
  Egypt: 'EGP',
  Ethiopia: 'ETB',
  France: '€',
  Germany: '€',
  India: '₹',
  Iraq: 'IQD',
  Italy: '€',
  Jordan: 'JOD',
  Kuwait: 'KWD',
  Lebanon: 'LBP',
  Libya: 'LYD',
  Malaysia: 'MYR',
  Morocco: 'MAD',
  Oman: 'OMR',
  Pakistan: '₨',
  Philippines: '₱',
  Qatar: 'QAR',
  'Saudi Arabia': 'SAR',
  'South Africa': 'R',
  Spain: '€',
  Sudan: 'SDG',
  Syria: 'SYP',
  Tunisia: 'TND',
  Turkey: '₺',
  'United Arab Emirates': 'AED',
  'United Kingdom': '£',
  'United States': '$',
  default: '$', // Fallback for unknown countries
};

const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;

  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(<i key={`full-${i}`} className="fa-solid fa-star text-orange-400 mr-1"></i>);
  }

  if (halfStar) {
    stars.push(<i key="half" className="fa-regular fa-star-half-stroke text-orange-400 mr-1"></i>);
  }

  while (stars.length < 5) {
    stars.push(<i key={`empty-${stars.length}`} className="fa-regular fa-star text-orange-400 mr-1"></i>);
  }

  return stars;
};


export default function Listing() {
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [totalPages, setTotalPages] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [productImages, setProductImages] = useState({});
  const [accessToken, setAccessToken] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [countryName, setCountryName] = useState('');
  const [selectionName, setSelectionName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [shopForName, setShopForName] = useState('');


  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    if (token) {
      setAccessToken(token);
      setIsLoggedIn(true);
      fetchUserWishlist(token);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const fetchUserWishlist = async (token) => {
    const decodedToken = jwtDecode(token);
    const idUser = decodedToken.id;

    try {
      const response = await axios.get(`${Constants.getUserWishlist}/${idUser}`);
      console.log('API Response:', response.data);

      if (response.data.status === 1) {
        const wishlistProductIds = response.data.list.map((item) => item.idProduct);
        setWishlist(wishlistProductIds);
      }
    } catch (error) {
      console.error('Error fetching user wishlist:', error);
    }
  };

  const location = useLocation();
  const [openFilter, setOpenFilter] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');
  const [hasActiveFilter, setHasActiveFilter] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  // console.log('API Response url:', queryParams);
  const idCountry = queryParams.get("country") || "";
  // console.log('list API Response idCountry:', idCountry);
  const idCategory = queryParams.get("category") || "";
  const idSelection = queryParams.get("selection") || "";
  const idShopFor = queryParams.get("shopFor") || "";
  const idRingStyle = queryParams.get("ringStyle") || "";
  const idPearlColor = queryParams.get("pearlColor") || "";
  const idPearlType = queryParams.get("pearlType") || "";
  const idDiamondColor = queryParams.get("diamondColor") || "";
  const idClarity = queryParams.get("clarity") || "";
  const idStoneColor = queryParams.get("stoneColor") || "";

  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${Constants.listProduct}?page=${currentPage}&limit=${limit}&keyword=${keyword}&idCountry=${idCountry}&idCategory=${idCategory}&idSelection=${idSelection}&idShopFor=${idShopFor}&idRingStyle=${idRingStyle}&idPearlColor=${idPearlColor}&idPearlType=${idPearlType}&idDiamondColor=${idDiamondColor}&idClarity=${idClarity}&idStoneColor=${idStoneColor}`
      );

      if (response.data.status === 1) {
        const activeProducts = response.data.list.filter(product => product.status === 'Active');
        setProducts(activeProducts);
        setTotalPages(response.data.pagination.totalPages);
        setPagination(response.data.pagination);
      } else {
        setProducts([]);
      }

    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    if (products.length > 0) {
      fetchImagesForProducts(products);
    }
  }, [products]); // Ensure this only runs when products change

  const fetchImagesForProducts = async (products) => {
    const images = {};
    try {
      await Promise.all(
        products.map(async (product) => {
          try {
            const response = await axios.get(`${Constants.getProductImagesById}/${product.id}`);

            if (response.data.status === 1 && response.data.data.length > 0) {
              const firstImage = response.data.data[0];
              images[product.id] = firstImage;
            } else {
              // 👇 Fallback for missing image
              images[product.id] = { image: 'product_default.png' };
            }

          } catch (error) {
            console.error(`Error fetching image for product ${product.id}:`, error);
            // 👇 Even if request fails, set default image
            images[product.id] = { image: 'product_default.png' };
          }
        })
      );

      console.log('Fetched product images:', images);
      setProductImages(images);

    } catch (error) {
      console.error('Error fetching product images:', error);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, [location.search, currentPage, limit, keyword]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1); // Reset to the first page on search
    fetchProducts();
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    // If there's a feedback message, set a timeout to hide it after 10 seconds
    if (feedbackMessage) {
      const timer = setTimeout(() => {
        setFeedbackMessage('');
        setFeedbackType('');
      }, 5000); // 10 seconds

      // Clear the timer if feedbackMessage changes before the timeout
      return () => clearTimeout(timer);
    }
  }, [feedbackMessage]);

  const handleWishlistClick = async (productId) => {
    if (!isLoggedIn) {
      setFeedbackMessage('Please log in to modify your wishlist.');
      setFeedbackType('error');
      return;
    }

    const decodedToken = jwtDecode(accessToken);
    const idUser = decodedToken.id;

    try {
      if (isProductInWishlist(productId)) {
        // 🔴 Remove from wishlist
        const response = await axios.delete(`${Constants.deleteFromWishlist}`, {
          idUser,
          idProduct: productId,
        });

        if (response.data.status === 1) {
          setWishlist(prev => prev.filter(id => id !== productId));
          setFeedbackMessage('Removed from wishlist');
          setFeedbackType('success');
        } else {
          setFeedbackMessage(response.data.message || 'Failed to remove from wishlist.');
          setFeedbackType('error');
        }

      } else {
        // ✅ Add to wishlist
        const response = await axios.post(`${Constants.addToWishlist}`, {
          idUser,
          idProduct: productId,
        });

        if (response.data.status === 1) {
          setWishlist(prev => [...prev, productId]);
          setFeedbackMessage('Product added to wishlist!');
          setFeedbackType('success');
        } else {
          setFeedbackMessage(response.data.message || 'Failed to add to wishlist.');
          setFeedbackType('error');
        }
      }
    } catch (error) {
      console.error('Wishlist error:', error);
      setFeedbackMessage('An error occurred.');
      setFeedbackType('error');
    }
  };

  const isProductInWishlist = (productId) => {
    return wishlist.includes(productId); // Check if the productId exists in the wishlist
  };

  const fetchCountryNames = async (countryIds) => {
    try {
      const countryPromises = countryIds.map(async (id) => {
        const response = await axios.get(`${Constants.getCountryById}/${id}`);
        return response.data.data.country;
      });
      const countries = await Promise.all(countryPromises);
      setCountryName(countries);
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  // Fetch selection name based on idSelection
  const fetchSelectionName = async (idSelection) => {
    try {
      const response = await axios.get(`${Constants.getSelectionById}/${idSelection}`);
      if (response.data.status === 1) {
        setSelectionName(response.data.data.name); // Assuming response contains the selection name in 'name' field
      }
    } catch (error) {
      console.error("Error fetching selection:", error);
    }
  };

  const fetchCategoryName = async (idCategory) => {
    try {
      const response = await axios.get(`${Constants.getCategoryById}/${idCategory}`);
      if (response.data.status === 1) {
        setCategoryName(response.data.data.name); // Assuming response contains the selection name in 'name' field
      }
    } catch (error) {
      console.error("Error fetching Category:", error);
    }
  };

  const fetchShopForName = async (idShopFor) => {
    try {
      const response = await axios.get(`${Constants.getShopForById}/${idShopFor}`);
      if (response.data.status === 1) {
        setShopForName(response.data.data.name);
      }
    } catch (error) {
      console.error("Error fetching ShopFor:", error);
    }
  };


  useEffect(() => {
    if (idCountry) {
      const countryIds = idCountry.split(',');
      fetchCountryNames(countryIds);
    }
    if (idSelection) {
      fetchSelectionName(idSelection);
    }
    if (idCategory) {
      fetchCategoryName(idCategory);
    }
    if (idShopFor) {
      fetchShopForName(idShopFor);
    }
  }, [idCountry, idSelection, idCategory, idShopFor]);

  const handleRemoveCountry = (countryToRemove) => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    // Get all current selected countries
    let countries = params.get('country')?.split(',') || [];

    // Remove the selected country
    countries = countries.filter(country => country !== countryToRemove);

    // Update the URL
    if (countries.length > 0) {
      params.set('country', countries.join(','));
    } else {
      params.delete('country');
    }

    url.search = params.toString();
    window.history.pushState({}, '', url.toString());

    // Update the state (countryName)
    if (countries.length > 0) {
      fetchCountriesFromAPI(countries); // Use the renamed function
    } else {
      setCountryName(''); // Reset if no countries are selected
    }

    // Fetch products based on the updated filters
    fetchProducts();
  };

  const fetchCountriesFromAPI = async (countryIds) => {
    try {
      const countryPromises = countryIds.map(async (id) => {
        const response = await axios.get(`${Constants.getCountryById}/${id}`);
        return response.data.data.country;
      });
      const countries = await Promise.all(countryPromises);
      setCountryName(countries); // Update country names
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  const handleRemoveSelection = () => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete('selection');
    url.search = params.toString();
    window.history.pushState({}, '', url.toString());

    // Update state for selection
    setSelectionName('');
    // Optionally, store in localStorage/sessionStorage
    localStorage.removeItem('selection');
    fetchProducts();
  };

  const handleRemoveCategory = () => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete('category');
    url.search = params.toString();
    window.history.pushState({}, '', url.toString());

    // Update state for selection
    setCategoryName('');
    // Optionally, store in localStorage/sessionStorage
    localStorage.removeItem('category');
    fetchProducts();
  };

  const handleRemoveShopFor = () => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete('shopFor');
    url.search = params.toString();
    window.history.pushState({}, '', url.toString());

    setShopForName('');
    localStorage.removeItem('shopFor');
    fetchProducts(); // Refresh product list
  };


  const handleClearAll = () => {
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);

    // Remove all query parameters
    params.delete('country');
    params.delete('selection');
    params.delete('category');
    params.delete('shopFor');

    url.search = params.toString();
    window.history.pushState({}, '', url.toString()); // Update the URL without reloading the page

    // Clear all states
    setCountryName('');
    setSelectionName('');
    setCategoryName('');
    setShopForName('');

    // Optionally, store in localStorage/sessionStorage
    localStorage.removeItem('country');
    localStorage.removeItem('selection');
    localStorage.removeItem('category');
    localStorage.removeItem('shopFor');


    // Reload the page to reflect the cleared filters
    window.location.reload();
  };
  useEffect(() => {
    // Check localStorage for saved values
    const storedCountry = localStorage.getItem('country');
    const storedSelection = localStorage.getItem('selection');
    const storedCategory = localStorage.getItem('category');
    const storedShopFor = localStorage.getItem('shopFor');

    if (storedCountry) {
      setCountryName(storedCountry);
    }

    if (storedSelection) {
      setSelectionName(storedSelection);
    }
    if (storedCategory) {
      setCategoryName(storedCategory);
    }
    if (storedShopFor) {
      setShopForName(storedShopFor);
    }
  }, []);

  return (
    <>
      <Breadcumb pagetitle="Shop" />
      <section className='py-10'>
        <div className='container mx-auto px-4'>
          {isMobile ? (
            <>
              {/* Mobile Filters Button */}
              <div className="flex justify-end mb-4">
                <Button
                  variant="outlined"
                  onClick={() => setOpenFilter(true)}
                  sx={{
                    borderColor: hasActiveFilter ? "black" : "#A27800",
                    color: hasActiveFilter ? "black" : "#A27800",
                    textTransform: "none",
                    fontWeight: 600,
                    "&:hover": {
                      borderColor: hasActiveFilter ? "black" : "#A27800",
                      color: hasActiveFilter ? "black" : "#A27800",
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <i className="fa-solid fa-sliders mr-2"></i> Filters
                </Button>
              </div>


              {/* Myntra-style Bottom Drawer */}
              <Drawer
                anchor="bottom"
                open={openFilter}
                onClose={() => setOpenFilter(false)}
                PaperProps={{
                  sx: {
                    height: "90vh",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    overflow: "hidden"
                  },
                }}
              >
                <div className="p-4 h-full flex flex-col">
                  <div
                    className={`flex justify-between items-center mb-4 px-4 py-2 rounded ${hasActiveFilter
                      ? "bg-[#A27800] text-white"
                      : "bg-gray-100 text-gray-800"
                      }`}
                  >
                    <h2 className="text-lg font-semibold">Filters</h2>
                    <button onClick={() => setOpenFilter(false)}>
                      <i className={`fa-solid fa-xmark text-xl ${hasActiveFilter ? "text-white" : "text-gray-600"
                        }`}></i>
                    </button>
                  </div>
                  <div className="flex-1 overflow-y-auto pr-2">
                    {/* ✅ Your Original Filter Sidebar */}
                    <Shopsidebar onFilterChange={(status) => {
                      const anyActive = Object.values(status).some(Boolean);
                      setHasActiveFilter(anyActive);
                    }} />
                  </div>
                  <div className="flex justify-between gap-3 mt-4">
                    <button
                      className="flex-1 bg-gray-200 text-gray-800 py-2 rounded"
                      onClick={handleClearAll}
                    >
                      Clear All
                    </button>
                    <button
                      className="flex-1 bg-[#A27800] text-white py-2 rounded"
                      onClick={() => setOpenFilter(false)}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </Drawer>

              {/* Mobile Product List */}
              {/* Mobile Product List (Clean Modern Style) */}
              <div className="space-y-4">
                {/* ✅ Feedback Message for Mobile */}
                {feedbackMessage && (
                  <div
                    className={`mt-4 p-3 text-center text-sm rounded-md ${feedbackType === 'success'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                      }`}
                  >
                    {feedbackMessage}
                  </div>
                )}
                {isLoading ? (
                  <p className="text-center text-gray-500">Loading...</p>
                ) : products.length === 0 ? (
                  <p className="text-center text-gray-500">No products found.</p>
                ) : (
                  products.map((product) => (
                    <div
                      key={product.id}
                      className="bg-white shadow-md rounded-lg overflow-hidden border border-gray-100 hover:shadow-lg transition-all"
                    >


                      {/* Wrap Entire Product Card in Link */}
                      <Link to={`/details/${product.id}`} className="flex w-full">
                        {/* Product Image */}
                        <div className="w-1/3 relative">
                          {productImages[product.id] ? (
                            <img
                              src={`${Constants.imageBaseURL}${productImages[product.id]?.image}`}
                              alt={product.categoryName}
                              className="object-cover w-full h-full"
                            />
                          ) : (
                            <div className="flex items-center justify-center w-full h-full bg-gray-100 text-gray-400 text-sm">
                              No Image
                            </div>
                          )}
                        </div>

                        {/* Product Info */}
                        <div className="w-2/3 p-3 flex flex-col justify-between">
                          <div>
                            {/* Top Row: Location + Wishlist */}
                            <div className="flex items-start justify-between mb-1">
                              <p className="text-xs text-gray-500">
                                {product.stateName}, {product.countryName}
                              </p>

                              {/* 🧡 Featured Wishlist Button */}
                              <button
                                onClick={(e) => {
                                  e.preventDefault(); // ✅ Stop Link navigation
                                  e.stopPropagation(); // ✅ Stop event bubbling
                                  handleWishlistClick(product.id);
                                }}
                                className={`w-[32px] h-[32px] flex items-center justify-center rounded-full shadow-[0_2px_6px_rgba(0,0,0,0.15)] border border-gray-200 bg-white 
    hover:bg-[#FFF6E5] hover:text-[#A27800] transition-all duration-200
    ${isProductInWishlist(product.id) ? 'text-[#A27800]' : 'text-gray-400'}`}
                              >
                                <i
                                  className={`fa-${isProductInWishlist(product.id) ? 'solid' : 'regular'} fa-heart text-[15px]`}
                                ></i>
                              </button>


                            </div>

                            {/* Product Title */}
                            <h3 className="font-semibold text-[15px] leading-tight mb-1">
                              {product.selectionName} {product.categoryName}
                            </h3>

                            {/* Category */}
                            <p className="text-sm text-gray-500 mb-1">{product.categoryName}</p>

                            {/* ⭐ Rating */}
                            <div className="flex items-center text-xs mb-1">
                              {renderStars(product.rating || 0)}
                              <span className="text-gray-500 ml-1">
                                ({product.totalReviews || 0} Review
                                {product.totalReviews === 1 ? "" : "s"})
                              </span>
                            </div>

                            {/* Description */}
                            <p className="text-xs text-gray-400 line-clamp-2">
                              {product.description
                                ? product.description.replace(/<[^>]*>/g, "")
                                : ""}
                            </p>
                          </div>

                          {/* Price */}
                          <div className="flex items-center justify-start mt-2">
                            <p className="text-[#B3902D] font-bold text-sm">
                              {countryCurrencySymbols.default} {product.price}
                            </p>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                )}
              </div>

              {/* Pagination */}
              <div className="flex justify-center mt-6">
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index}
                    className={`px-3 py-1 mx-1 text-sm rounded ${currentPage === index + 1
                      ? "bg-[#A27800] text-white"
                      : "border border-gray-400 text-gray-600"
                      }`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>


            </>
          ) : (

            <Grid container spacing={4}>
              <Grid item lg={3} md={12} xs={12}>
                <Shopsidebar />
              </Grid>

              <Grid item lg={9} md={12} >
                <div className='mb-5 flex gap-1'>
                  {countryName.length > 0 && countryName.map((country, index) => (
                    <span key={index} className='flex gap-2 py-1 px-3 bg-[#ccc] text-black text-sm'>
                      <button onClick={() => handleRemoveCountry(country)}>
                        <i className="fa-sharp fa-regular fa-xmark"></i>
                      </button>
                      {country}
                    </span>
                  ))}
                  {selectionName && (
                    <span className='flex gap-2 py-1 px-3 bg-[#ccc] text-black text-sm'>
                      <button onClick={handleRemoveSelection}>
                        <i className="fa-sharp fa-regular fa-xmark"></i>
                      </button>
                      {selectionName}
                    </span>
                  )}
                  {categoryName && (
                    <span className='flex gap-2 py-1 px-3 bg-[#ccc] text-black text-sm'>
                      <button onClick={handleRemoveCategory}>
                        <i className="fa-sharp fa-regular fa-xmark"></i>
                      </button>
                      {categoryName}
                    </span>
                  )}
                  {shopForName && (
                    <span className='flex gap-2 py-1 px-3 bg-[#ccc] text-black text-sm'>
                      <button onClick={handleRemoveShopFor}>
                        <i className="fa-sharp fa-regular fa-xmark"></i>
                      </button>
                      {shopForName}
                    </span>
                  )}
                  <button
                    className='flex gap-2 py-1 px-3 bg-[#A27800] text-white text-sm'
                    onClick={handleClearAll}
                  >
                    Clear All
                  </button>
                </div>
                <div className="flex gap-3 mb-5 justify-between items-center">
                  <div className="capitalize text-sm text-gray-600">
                    Showing all {products.length} of {pagination?.totalItems || 0} results
                  </div>
                  <select
                    className="px-3 py-2 border border-gray-500 text-sm min-w-32"
                    value={limit}
                    onChange={(e) => setLimit(Number(e.target.value))}
                  >
                    <option value={10}>10 per page</option>
                    <option value={20}>20 per page</option>
                    <option value={50}>50 per page</option>
                  </select>
                </div>
                {feedbackMessage && (
                  <div
                    className={`mt-4 p-4 text-center rounded-md ${feedbackType === 'success'
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                      }`}
                  >
                    {feedbackMessage}
                  </div>
                )}


                {isLoading ? (
                  <p>Loading...</p>
                ) : products.length === 0 ? (
                  <p>No products found.</p>  // This will display the message when there are no products
                ) : (
                  products.map((product) => (
                    <div key={product.id} className="mb-8">
                      <Grid container spacing={3} className="justify-center">
                        <Grid item lg={4} md={5} sm={5} xs={12}>
                          <Link to="#">
                            {productImages[product.id] ? (
                              <img
                                className="aspect-square object-contain w-full border"
                                src={`${Constants.imageBaseURL}${productImages[product.id]?.image}`}
                                alt={`Product ${product.id}`}
                              />
                            ) : (
                              <span>No Image</span> // Display this if no image is available
                            )}
                          </Link>
                        </Grid>
                        <Grid item lg={8} md={7} sm={7}>
                          <span className="inline-block px-3 py-1 bg-[#A27800] text-white text-sm rounded mb-3">
                            <Link to="">
                              <i className="fa-sharp fa-regular fa-location-dot mr-2"></i>{" "}
                              {product.countryName}, {product.stateName}
                            </Link>
                          </span>
                          <h2 className="md:text-3xl text-2xl headningfont mb-2 font-semibold">
                            <Link to="">{product.selectionName} {product.categoryName}</Link>
                          </h2>
                          <h3 className="mb-3 text-gray-600">
                            <Link to="">Category: {product.categoryName}</Link>
                          </h3>
                          <h5 className="mb-3 text-base tracking-widest">
                            {renderStars(product.rating || 0)}
                            <span className="text-gray-600 text-sm">
                              ({product.totalReviews || 0} Review{product.totalReviews === 1 ? '' : 's'})
                            </span>
                          </h5>
                          <h4 className="md:text-lg text-sm mb-2 flex gap-3">
                            {/* <span className="text-gray-400 line-through">
                          {countryCurrencySymbols[product.country?.trim()] || countryCurrencySymbols.default} {product.originalPrice}
                        </span> */}
                            <span className="text-[#B3902D] font-semibold">
                              {countryCurrencySymbols.default} {product.price}
                            </span>
                          </h4>
                          <div className="flex my-4 gap-4 border-b pb-6">
                            <Link
                              to={`/details/${product.id}`}
                              className="bg-black text-white text-center rounded px-6 text-sm h-[45px] leading-[45px] uppercase font-semibold tracking-wider hover:bg-[#A27800] transition-all"
                            >
                              Check Availability
                            </Link>
                            {/* <button className="border border-black text-center rounded px-3 text-lg h-[45px] hover:bg-[#A27800] hover:border-[#A27800] hover:text-white transition-all">
                            <i className="fa-regular fa-heart"></i>
                          </button> */}
                            {/* Display feedback message */}

                            <button
                              onClick={() => handleWishlistClick(product.id)}
                              className={`border border-black text-center rounded px-3 text-lg h-[45px] hover:bg-[#A27800] transition-all ${isProductInWishlist(product.id) ? 'text text-color-white bg-[#A27800]' : ''}`}
                            >
                              <i className="fa-regular fa-heart"></i>
                            </button>
                          </div>
                          <p className="text-gray-500">
                            {product.description ? product.description.replace(/<[^>]*>/g, "") : ''}
                          </p>
                        </Grid>
                      </Grid>
                    </div>
                  ))
                )}
                <div className="flex justify-center mt-6">
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      className={`px-3 py-2 mx-1 ${currentPage === index + 1
                        ? "bg-black text-white"
                        : "border border-gray-500"
                        }`}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </Grid>

            </Grid>
          )}
        </div>
      </section>
    </>
  )
}
